// @flow

export function getUrlProperties(url: string): UrlProperties {
  const splittedUrl = url.split('/');

  return {
    protocol: splittedUrl[0].replace(':', ''),
    hostname: splittedUrl[2],
  };
}



// WEBPACK FOOTER //
// ./app/request/url/utils.js